/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ApGeneralInputOption } from '../model/apGeneralInputOption';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetApInvoiceTransactionGeneralInputOptions200 } from '../model/getApInvoiceTransactionGeneralInputOptions200';
import type { GetApInvoiceTransactionGeneralInputOptionsParams } from '../model/getApInvoiceTransactionGeneralInputOptionsParams';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { PostApGeneralInputOptions201 } from '../model/postApGeneralInputOptions201';
import type { PostApGeneralInputOptionsBody } from '../model/postApGeneralInputOptionsBody';
import type { PutApGeneralInputOptions200 } from '../model/putApGeneralInputOptions200';
import type { PutApGeneralInputOptionsBody } from '../model/putApGeneralInputOptionsBody';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get a list of AP invoice transaction general input options
 */
export const useGetApInvoiceTransactionGeneralInputOptionsHook = () => {
  const getApInvoiceTransactionGeneralInputOptions =
    useCustomClient<GetApInvoiceTransactionGeneralInputOptions200>();

  return (
    id: string,
    params?: GetApInvoiceTransactionGeneralInputOptionsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getApInvoiceTransactionGeneralInputOptions(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${id}/options`,
        method: 'GET',
        params,
      },
      options
    );
  };
};

export const getGetApInvoiceTransactionGeneralInputOptionsQueryKey = (
  id: string,
  params?: GetApInvoiceTransactionGeneralInputOptionsParams
) => {
  return [
    `/api/js/ap_invoice_transaction_general_inputs/${id}/options`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetApInvoiceTransactionGeneralInputOptionsInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      GetApInvoiceTransactionGeneralInputOptionsParams['page']
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
    >
  >(
    id: string,
    params?: GetApInvoiceTransactionGeneralInputOptionsParams,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApInvoiceTransactionGeneralInputOptionsHook
              >
            >
          >,
          TError,
          TData,
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApInvoiceTransactionGeneralInputOptionsHook
              >
            >
          >,
          QueryKey,
          GetApInvoiceTransactionGeneralInputOptionsParams['page']
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApInvoiceTransactionGeneralInputOptionsQueryKey(id, params);

    const getApInvoiceTransactionGeneralInputOptions =
      useGetApInvoiceTransactionGeneralInputOptionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      QueryKey,
      GetApInvoiceTransactionGeneralInputOptionsParams['page']
    > = ({ pageParam }) =>
      getApInvoiceTransactionGeneralInputOptions(
        id,
        { ...params, page: pageParam || params?.['page'] },
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      TError,
      TData,
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      QueryKey,
      GetApInvoiceTransactionGeneralInputOptionsParams['page']
    > & { queryKey: QueryKey };
  };

export type GetApInvoiceTransactionGeneralInputOptionsInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >
  >;
export type GetApInvoiceTransactionGeneralInputOptionsInfiniteQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >;

/**
 * @summary Get a list of AP invoice transaction general input options
 */
export const useGetApInvoiceTransactionGeneralInputOptionsInfinite = <
  TData = InfiniteData<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >,
    GetApInvoiceTransactionGeneralInputOptionsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  params?: GetApInvoiceTransactionGeneralInputOptionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        QueryKey,
        GetApInvoiceTransactionGeneralInputOptionsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputOptionsInfiniteQueryOptions(
      id,
      params,
      options
    );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionGeneralInputOptionsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  params?: GetApInvoiceTransactionGeneralInputOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApInvoiceTransactionGeneralInputOptionsQueryKey(id, params);

  const getApInvoiceTransactionGeneralInputOptions =
    useGetApInvoiceTransactionGeneralInputOptionsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >
  > = () =>
    getApInvoiceTransactionGeneralInputOptions(id, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionGeneralInputOptionsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
    >
  >
>;
export type GetApInvoiceTransactionGeneralInputOptionsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get a list of AP invoice transaction general input options
 */
export const useGetApInvoiceTransactionGeneralInputOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  params?: GetApInvoiceTransactionGeneralInputOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputOptionsQueryOptions(
      id,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionGeneralInputOptionsSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
    >
  >(
    id: string,
    params?: GetApInvoiceTransactionGeneralInputOptionsParams,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApInvoiceTransactionGeneralInputOptionsHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApInvoiceTransactionGeneralInputOptionsQueryKey(id, params);

    const getApInvoiceTransactionGeneralInputOptions =
      useGetApInvoiceTransactionGeneralInputOptionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >
    > = () =>
      getApInvoiceTransactionGeneralInputOptions(id, params, requestOptions);

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApInvoiceTransactionGeneralInputOptionsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >
  >;
export type GetApInvoiceTransactionGeneralInputOptionsSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >;

/**
 * @summary Get a list of AP invoice transaction general input options
 */
export const useGetApInvoiceTransactionGeneralInputOptionsSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  params?: GetApInvoiceTransactionGeneralInputOptionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputOptionsSuspenseQueryOptions(
      id,
      params,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionGeneralInputOptionsSuspenseInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      GetApInvoiceTransactionGeneralInputOptionsParams['page']
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
    >
  >(
    id: string,
    params?: GetApInvoiceTransactionGeneralInputOptionsParams,
    options?: {
      query?: Partial<
        UseSuspenseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApInvoiceTransactionGeneralInputOptionsHook
              >
            >
          >,
          TError,
          TData,
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApInvoiceTransactionGeneralInputOptionsHook
              >
            >
          >,
          QueryKey,
          GetApInvoiceTransactionGeneralInputOptionsParams['page']
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApInvoiceTransactionGeneralInputOptionsQueryKey(id, params);

    const getApInvoiceTransactionGeneralInputOptions =
      useGetApInvoiceTransactionGeneralInputOptionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      QueryKey,
      GetApInvoiceTransactionGeneralInputOptionsParams['page']
    > = ({ pageParam }) =>
      getApInvoiceTransactionGeneralInputOptions(
        id,
        { ...params, page: pageParam || params?.['page'] },
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseSuspenseInfiniteQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      TError,
      TData,
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
        >
      >,
      QueryKey,
      GetApInvoiceTransactionGeneralInputOptionsParams['page']
    > & { queryKey: QueryKey };
  };

export type GetApInvoiceTransactionGeneralInputOptionsSuspenseInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >
  >;
export type GetApInvoiceTransactionGeneralInputOptionsSuspenseInfiniteQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >;

/**
 * @summary Get a list of AP invoice transaction general input options
 */
export const useGetApInvoiceTransactionGeneralInputOptionsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
      >
    >,
    GetApInvoiceTransactionGeneralInputOptionsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  params?: GetApInvoiceTransactionGeneralInputOptionsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionsHook>
          >
        >,
        QueryKey,
        GetApInvoiceTransactionGeneralInputOptionsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputOptionsSuspenseInfiniteQueryOptions(
      id,
      params,
      options
    );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Create an AP general input option
 */
export const usePostApGeneralInputOptionsHook = () => {
  const postApGeneralInputOptions =
    useCustomClient<PostApGeneralInputOptions201>();

  return (
    id: string,
    postApGeneralInputOptionsBody: BodyType<PostApGeneralInputOptionsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postApGeneralInputOptions(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${id}/options`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postApGeneralInputOptionsBody,
      },
      options
    );
  };
};

export const usePostApGeneralInputOptionsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostApGeneralInputOptionsHook>>>,
    TError,
    { id: string; data: BodyType<PostApGeneralInputOptionsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostApGeneralInputOptionsHook>>>,
  TError,
  { id: string; data: BodyType<PostApGeneralInputOptionsBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postApGeneralInputOptions = usePostApGeneralInputOptionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostApGeneralInputOptionsHook>>>,
    { id: string; data: BodyType<PostApGeneralInputOptionsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApGeneralInputOptions(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApGeneralInputOptionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePostApGeneralInputOptionsHook>>>
>;
export type PostApGeneralInputOptionsMutationBody =
  BodyType<PostApGeneralInputOptionsBody>;
export type PostApGeneralInputOptionsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Create an AP general input option
 */
export const usePostApGeneralInputOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostApGeneralInputOptionsHook>>>,
    TError,
    { id: string; data: BodyType<PostApGeneralInputOptionsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = usePostApGeneralInputOptionsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get a single AP invoice transaction general input option by ID
 */
export const useGetApInvoiceTransactionGeneralInputOptionHook = () => {
  const getApInvoiceTransactionGeneralInputOption =
    useCustomClient<ApGeneralInputOption>();

  return (
    apInvoiceTransactionGeneralInputId: string,
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApInvoiceTransactionGeneralInputOption(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${apInvoiceTransactionGeneralInputId}/options/${id}`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApInvoiceTransactionGeneralInputOptionQueryKey = (
  apInvoiceTransactionGeneralInputId: string,
  id: string
) => {
  return [
    `/api/js/ap_invoice_transaction_general_inputs/${apInvoiceTransactionGeneralInputId}/options/${id}`,
  ] as const;
};

export const useGetApInvoiceTransactionGeneralInputOptionQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  apInvoiceTransactionGeneralInputId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApInvoiceTransactionGeneralInputOptionQueryKey(
      apInvoiceTransactionGeneralInputId,
      id
    );

  const getApInvoiceTransactionGeneralInputOption =
    useGetApInvoiceTransactionGeneralInputOptionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
      >
    >
  > = ({ signal }) =>
    getApInvoiceTransactionGeneralInputOption(
      apInvoiceTransactionGeneralInputId,
      id,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(apInvoiceTransactionGeneralInputId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionGeneralInputOptionQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
    >
  >
>;
export type GetApInvoiceTransactionGeneralInputOptionQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get a single AP invoice transaction general input option by ID
 */
export const useGetApInvoiceTransactionGeneralInputOption = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  apInvoiceTransactionGeneralInputId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApInvoiceTransactionGeneralInputOptionQueryOptions(
    apInvoiceTransactionGeneralInputId,
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionGeneralInputOptionSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
      >
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
    >
  >(
    apInvoiceTransactionGeneralInputId: string,
    id: string,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApInvoiceTransactionGeneralInputOptionHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApInvoiceTransactionGeneralInputOptionQueryKey(
        apInvoiceTransactionGeneralInputId,
        id
      );

    const getApInvoiceTransactionGeneralInputOption =
      useGetApInvoiceTransactionGeneralInputOptionHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
        >
      >
    > = ({ signal }) =>
      getApInvoiceTransactionGeneralInputOption(
        apInvoiceTransactionGeneralInputId,
        id,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(apInvoiceTransactionGeneralInputId && id),
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApInvoiceTransactionGeneralInputOptionSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
      >
    >
  >;
export type GetApInvoiceTransactionGeneralInputOptionSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >;

/**
 * @summary Get a single AP invoice transaction general input option by ID
 */
export const useGetApInvoiceTransactionGeneralInputOptionSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  apInvoiceTransactionGeneralInputId: string,
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputOptionHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputOptionSuspenseQueryOptions(
      apInvoiceTransactionGeneralInputId,
      id,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update an AP general input option
 */
export const usePutApGeneralInputOptionsHook = () => {
  const putApGeneralInputOptions =
    useCustomClient<PutApGeneralInputOptions200>();

  return (
    apInvoiceTransactionGeneralInputId: string,
    id: string,
    putApGeneralInputOptionsBody: BodyType<PutApGeneralInputOptionsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return putApGeneralInputOptions(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${apInvoiceTransactionGeneralInputId}/options/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: putApGeneralInputOptionsBody,
      },
      options
    );
  };
};

export const usePutApGeneralInputOptionsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutApGeneralInputOptionsHook>>>,
    TError,
    {
      apInvoiceTransactionGeneralInputId: string;
      id: string;
      data: BodyType<PutApGeneralInputOptionsBody>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePutApGeneralInputOptionsHook>>>,
  TError,
  {
    apInvoiceTransactionGeneralInputId: string;
    id: string;
    data: BodyType<PutApGeneralInputOptionsBody>;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const putApGeneralInputOptions = usePutApGeneralInputOptionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePutApGeneralInputOptionsHook>>>,
    {
      apInvoiceTransactionGeneralInputId: string;
      id: string;
      data: BodyType<PutApGeneralInputOptionsBody>;
    }
  > = (props) => {
    const { apInvoiceTransactionGeneralInputId, id, data } = props ?? {};

    return putApGeneralInputOptions(
      apInvoiceTransactionGeneralInputId,
      id,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApGeneralInputOptionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePutApGeneralInputOptionsHook>>>
>;
export type PutApGeneralInputOptionsMutationBody =
  BodyType<PutApGeneralInputOptionsBody>;
export type PutApGeneralInputOptionsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update an AP general input option
 */
export const usePutApGeneralInputOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutApGeneralInputOptionsHook>>>,
    TError,
    {
      apInvoiceTransactionGeneralInputId: string;
      id: string;
      data: BodyType<PutApGeneralInputOptionsBody>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = usePutApGeneralInputOptionsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Delete an AP general input option
 */
export const useDeleteApGeneralInputOptionsHook = () => {
  const deleteApGeneralInputOptions = useCustomClient<void>();

  return (
    apInvoiceTransactionGeneralInputId: string,
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return deleteApGeneralInputOptions(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${apInvoiceTransactionGeneralInputId}/options/${id}`,
        method: 'DELETE',
      },
      options
    );
  };
};

export const useDeleteApGeneralInputOptionsMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteApGeneralInputOptionsHook>>>,
    TError,
    { apInvoiceTransactionGeneralInputId: string; id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteApGeneralInputOptionsHook>>>,
  TError,
  { apInvoiceTransactionGeneralInputId: string; id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const deleteApGeneralInputOptions = useDeleteApGeneralInputOptionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteApGeneralInputOptionsHook>>>,
    { apInvoiceTransactionGeneralInputId: string; id: string }
  > = (props) => {
    const { apInvoiceTransactionGeneralInputId, id } = props ?? {};

    return deleteApGeneralInputOptions(
      apInvoiceTransactionGeneralInputId,
      id,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApGeneralInputOptionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteApGeneralInputOptionsHook>>>
>;

export type DeleteApGeneralInputOptionsMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Delete an AP general input option
 */
export const useDeleteApGeneralInputOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteApGeneralInputOptionsHook>>>,
    TError,
    { apInvoiceTransactionGeneralInputId: string; id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useDeleteApGeneralInputOptionsMutationOptions(options);

  return useMutation(mutationOptions);
};
